export const PURPLE_DARK = '#1e0e4e';
export const PURPLE = '#5124a6';
export const PURPLE_LIGHT = '#8b5cf6';
export const HERO_GRAD = `linear-gradient(150deg, #ffffff 0%, #ede8ff 50%, #d4c4ff 100%)`;
export const ACCENT_GRAD = `linear-gradient(135deg, ${PURPLE}, ${PURPLE_LIGHT})`;

export const RADII = { sm: '8px', md: '12px', lg: '16px', xl: '24px', pill: '999px' };
export const SHADOWS = {
    sm: '0 2px 12px rgba(26,15,58,0.08)',
    md: '0 8px 24px rgba(26,15,58,0.1)',
    lg: '0 16px 48px rgba(26,15,58,0.14)',
};

/* ---- Restyle tokens (POK design system — Holder 2.0) ---- */

export const FONTS = {
    sans: "Geist, 'Geist Fallback', sans-serif",
    mono: "'Geist Mono', monospace",
    serif: "Georgia, 'Times New Roman', serif",
};

/* Text + accent ramp */
export const INK = '#1E1E1E';
export const FG_2 = '#584F64';
export const FG_3 = '#716B94';
export const BLUE = '#548CFF';
export const CYAN = '#49DEFF';
export const YELLOW = '#FFCC00';
export const LINE = '#D9D9D9';
export const PRIMARY_TINT = '#EBEBFF';

/* Section surfaces */
export const SURFACE = {
    lavender: '#F3F2F8',
    beige: '#F3EFE9',
    cool: '#EEEFF6',
};

/* Subtle blueprint grid used on lavender sections (hero, reviews, blog) */
export const gridBg = (base = SURFACE.lavender, line = 'rgba(26,23,38,0.04)', size = 62) => ({
    backgroundColor: base,
    backgroundImage: `linear-gradient(${line} 1px, transparent 1px), linear-gradient(90deg, ${line} 1px, transparent 1px)`,
    backgroundSize: `${size}px ${size}px`,
});

/* Mono uppercase eyebrow above section headings */
export const eyebrow = {
    fontFamily: FONTS.mono,
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: BLUE,
};
